export default "__VITE_ASSET__$tKsLL2v__"